import React from "react";

const Admintools = React.lazy(() => import('./Admintools'));
export const admintoolsConfig = [
    {
        path: '/apps/admintools',
        element: <Admintools />,
        roleAccess: ['ADMIN_TOOLS']
    },
    {
        path: '/apps/admintools/:page',
        element: <Admintools />,
        roleAccess: ['ADMIN_TOOLS', 'CRSFE_ADMIN_PENOMORAN']
    },
    {
        path: '/apps/admintools/:page/:type',
        element: <Admintools />,
        roleAccess: ['ADMIN_TOOLS']
    },
    {
        path: '/apps/admintools/:page/:type/:id',
        element: <Admintools />,
        roleAccess: ['ADMIN_TOOLS']
    },
];